<template>
    <!-- Admin Summary Mobile View -->
    <div class="d-md-none admin-mobile-container" v-if="dashboardMode === ''">
        <div class="d-flex deals overflow-scroll d-flex ms-4">
            <!-- Total Corporate -->
            <div class="me-4">
                <o-widget-mini class="custom-width-widget-mini">
                    <template v-slot:card-name>
                        Total Corporate
                    </template>
                    <template v-slot:card-value>
                        {{ adminSummary.totalCorporates || 0 }}
                    </template>
                    <template v-slot:icon-big>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 16 16">
                            <path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"/>
                            <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1Zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3V1Z"/>
                        </svg>
                    </template>
                </o-widget-mini>
            </div>

            <!-- Total Merchant -->
            <div class="me-4">
                <o-widget-mini class="custom-width-widget-mini">
                    <template v-slot:card-name>
                        Total Merchant
                    </template>
                    <template v-slot:card-value>
                        {{ adminSummary.totalMerchants || 0 }}
                    </template>
                    <template v-slot:icon-big>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 16 16">
                            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                        </svg>
                    </template>
                </o-widget-mini>
            </div>

            <!-- Total Members -->
            <div class="me-4">
                <o-widget-mini class="custom-width-widget-mini">
                    <template v-slot:card-name>
                        Total Members
                    </template>
                    <template v-slot:card-value>
                        {{ adminSummary.totalMembers || 0 }}
                    </template>
                    <template v-slot:icon-big>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 16 16">
                            <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                            <path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/>
                            <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                        </svg>
                    </template>
                </o-widget-mini>
            </div>

            <!-- Today Transaction Value -->
            <div class="me-4">
                <o-widget-mini class="custom-width-widget-mini">
                    <template v-slot:card-name>
                        Today Transaction Value
                    </template>
                    <template v-slot:card-value>
                        IDR {{ adminSummary.todayTransactionValue || 0 }}
                    </template>
                    <template v-slot:icon-big>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 16 16">
                            <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
                            <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z"/>
                        </svg>
                    </template>
                </o-widget-mini>
            </div>

            <!-- Today New Member -->
            <div class="me-4">
                <o-widget-mini class="custom-width-widget-mini">
                    <template v-slot:card-name>
                        Today New Member
                    </template>
                    <template v-slot:card-value>
                        {{ adminSummary.todayNewMembers || 0 }}
                    </template>
                    <template v-slot:icon-big>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 16 16">
                            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                        </svg>
                    </template>
                </o-widget-mini>
            </div>

            <!-- Today Voucher Claimed -->
            <div class="me-4" v-if="isPointSystemActive">
                <o-widget-mini class="custom-width-widget-mini">
                    <template v-slot:card-name>
                        Today Voucher Claimed
                    </template>
                    <template v-slot:card-value>
                        {{ adminSummary.todayVoucherClaimed || 0 }}
                    </template>
                    <template v-slot:icon-big>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 16 16">
                            <path d="M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5z"/>
                        </svg>
                    </template>
                </o-widget-mini>
            </div>
        </div>
    </div>

    <!-- Regular Dashboard Mobile View -->
    <div class="d-md-none" v-if="dashboardMode !== '' && gain?.transaction">
        <div class="d-flex deals overflow-scroll d-flex ms-4">
            <div class="me-4">
                <o-widget-mini class="custom-width-widget-mini" :gain="gain?.transaction.gain">
                <template v-slot:card-name>
                    Transaction Value
                </template>
                <template v-slot:card-value>
                    {{ gain?.transaction.value }}
                </template>
                <template v-slot:icon-big>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="35" fill="none" viewBox="0 0 40 35">
                        <path fill="#FEFEFE" d="M6.693 0c.801 0 1.492.56 1.645 1.334l.105.853h29.33c1.414 0 2.544 1.385 2.146 2.78l-3.764 13.128a2.226 2.226 0 0 1-2.148 1.593H11.901l.64 3.28h21.48c.928 0 1.674.732 1.674 1.641 0 .91-.746 1.641-1.673 1.641h-22.93c-.74 0-1.43-.56-1.583-1.333L5.31 3.281H1.672C.75 3.281 0 2.546 0 1.641 0 .735.75 0 1.673 0h5.02Zm2.23 31.719c0-1.812 1.5-3.282 3.347-3.282 1.848 0 3.346 1.47 3.346 3.282 0 1.811-1.498 3.281-3.346 3.281-1.847 0-3.346-1.47-3.346-3.281Zm26.772 0c0 1.811-1.5 3.281-3.347 3.281s-3.346-1.47-3.346-3.281c0-1.812 1.499-3.282 3.346-3.282 1.848 0 3.347 1.47 3.347 3.282Z"/>
                    </svg>
                </template>
                </o-widget-mini>
            </div>
            <div class="me-4" v-if="isPointSystemActive">
                <o-widget-mini class="custom-width-widget-mini" :gain="gain?.voucher.gain">
                    <template v-slot:card-name>
                    Voucher Claimed
                    </template>
                    <template v-slot:card-value>
                    {{ gain?.voucher.claimed }}
                    </template>
                    <template v-slot:icon-big>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="27" fill="none" viewBox="0 0 40 27">
                        <path fill="#fff" d="M0 4.39C0 1.965 1.99 0 4.444 0h31.112C38.006 0 40 1.965 40 4.39v5.488c-1.84 0-3.333 1.475-3.333 3.293S38.16 16.463 40 16.463v5.488c0 2.422-1.993 4.39-4.444 4.39H4.444C1.99 26.341 0 24.373 0 21.951v-5.488c1.841 0 3.333-1.474 3.333-3.292 0-1.818-1.492-3.293-3.333-3.293V4.39Z"/>
                        </svg>
                    </template>
                </o-widget-mini>
            </div>
            <div class="me-4">
                <o-widget-mini class="custom-width-widget-mini" :gain="gain?.member.gain">
                <template v-slot:card-name>
                    New Member
                </template>
                <template v-slot:card-value>
                    {{ gain?.member.claimed }}
                </template>
                <template v-slot:icon-big>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="28" fill="none" viewBox="0 0 40 28">
                        <path fill="#fff" d="M11.5 3.378c0 1.865-1.569 3.379-3.5 3.379-1.933 0-3.5-1.514-3.5-3.379C4.5 1.512 6.067 0 8 0c1.931 0 3.5 1.512 3.5 3.378Zm1.525 6.534C11.169 11.505 10 13.827 10 16.409c0 2.07.694 3.97 2 5.46v1.297c0 1.068-.894 1.93-2 1.93H6c-1.104 0-2-.862-2-1.93v-1.617c-2.365-1.086-4-3.408-4-6.105 0-3.734 3.134-6.757 7-6.757h2a7.28 7.28 0 0 1 4.025 1.225ZM4 12.892a3.76 3.76 0 0 0 0 5.104v-5.104Zm24 10.274v-1.297c1.25-1.49 2-3.39 2-5.46 0-2.582-1.169-4.904-3.025-6.497A7.144 7.144 0 0 1 31 8.687h2c3.869 0 7 3.023 7 6.757 0 2.697-1.638 5.02-4 6.105v1.617c0 1.068-.894 1.93-2 1.93h-4c-1.106 0-2-.862-2-1.93Zm8-5.17c.569-.676 1-1.575 1-2.552 0-.977-.431-1.876-1-2.552v5.104Zm-.5-14.618c0 1.865-1.569 3.379-3.5 3.379s-3.5-1.514-3.5-3.379C28.5 1.512 30.069 0 32 0s3.5 1.512 3.5 3.378ZM16 3.861C16 1.728 17.794 0 20 0s4 1.728 4 3.861c0 2.13-1.794 3.861-4 3.861s-4-1.731-4-3.861Zm12 12.548c0 2.697-1.637 5.02-4 6.106v2.581c0 1.068-.894 1.931-2 1.931h-4c-1.106 0-2-.863-2-1.93v-2.582c-2.363-1.086-4-3.41-4-6.106 0-3.734 3.131-6.756 7-6.756h2c3.869 0 7 3.022 7 6.756Zm-12 2.552v-5.104a3.75 3.75 0 0 0-1 2.552c0 .978.375 1.877 1 2.552Zm8-5.104v5.104c.569-.682 1-1.574 1-2.552 0-.977-.431-1.876-1-2.552Z"/>
                    </svg>
                </template>
                </o-widget-mini>
            </div>
            <div class="me-4" v-if="dashboardMode == 'merchant'">
                <o-widget-mini class="custom-width-widget-mini">
                <template v-slot:card-name>
                    Best Product
                </template>
                <template v-slot:card-value>
                    {{ gain?.best_product }}
                </template>
                <template v-slot:icon-big>
                    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" fill="none" viewBox="0 0 31 31">
                        <path fill="#fff" d="M13.545 7.92 9.028.47C8.907.18 8.592 0 8.253 0H.97a.969.969 0 0 0-.793 1.525l6.74 9.62a12.518 12.518 0 0 1 6.628-3.225Zm1.956 1.768c-5.889 0-10.657 4.768-10.657 10.656C4.844 26.232 9.615 31 15.5 31s10.66-4.768 10.66-10.656A10.651 10.651 0 0 0 15.5 9.687Zm5.601 9.524-2.293 2.24.537 3.163c.098.56-.5 1-1.007.727l-2.839-1.49-2.839 1.487a.692.692 0 0 1-1.007-.727l.538-3.163-2.294-2.24c-.416-.403-.18-1.105.39-1.19l3.171-.462 1.418-2.874a.675.675 0 0 1 .621-.386c.25 0 .5.131.62.386l1.424 2.876 3.172.461a.697.697 0 0 1 .388 1.192ZM29.98 0h-7.23a.969.969 0 0 0-.83.47l-4.467 7.393a12.486 12.486 0 0 1 6.63 3.232l6.74-9.62C31.275.882 30.815 0 29.98 0Z"/>
                    </svg>  
                </template>
                </o-widget-mini>
            </div>
            <div class="me-4" v-else>
                <o-widget-mini class="custom-width-widget-mini">
                <template v-slot:card-name>
                    Best Performer
                </template>
                <template v-slot:card-value>
                    {{ gain?.performer.claimed }}
                </template>
                <template v-slot:icon-big>
                    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" fill="none" viewBox="0 0 31 31">
                        <path fill="#fff" d="M13.545 7.92 9.028.47C8.907.18 8.592 0 8.253 0H.97a.969.969 0 0 0-.793 1.525l6.74 9.62a12.518 12.518 0 0 1 6.628-3.225Zm1.956 1.768c-5.889 0-10.657 4.768-10.657 10.656C4.844 26.232 9.615 31 15.5 31s10.66-4.768 10.66-10.656A10.651 10.651 0 0 0 15.5 9.687Zm5.601 9.524-2.293 2.24.537 3.163c.098.56-.5 1-1.007.727l-2.839-1.49-2.839 1.487a.692.692 0 0 1-1.007-.727l.538-3.163-2.294-2.24c-.416-.403-.18-1.105.39-1.19l3.171-.462 1.418-2.874a.675.675 0 0 1 .621-.386c.25 0 .5.131.62.386l1.424 2.876 3.172.461a.697.697 0 0 1 .388 1.192ZM29.98 0h-7.23a.969.969 0 0 0-.83.47l-4.467 7.393a12.486 12.486 0 0 1 6.63 3.232l6.74-9.62C31.275.882 30.815 0 29.98 0Z"/>
                    </svg>  
                </template>
                </o-widget-mini>
            </div>
            <div class="me-4" v-if="isPointSystemActive">
                <o-widget-mini class="custom-width-widget-extended">
                <template v-slot:card-name>
                    Most Loyal Member
                </template>
                <template v-slot:card-value>
                    {{ gain?.loyal_member.name }}
                </template>
                <template v-slot:icon-big>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="32" fill="none" viewBox="0 0 40 32">
                        <path fill="#fff" d="M40 7.222A2.776 2.776 0 0 1 37.227 10c-.018 0-.032-.009-.05-.01l-3.502 19.3a2.22 2.22 0 0 1-2.182 1.821H8.57a2.22 2.22 0 0 1-2.183-1.824L2.885 9.993c-.017 0-.032.007-.112.007A2.776 2.776 0 0 1 0 7.222c0-1.534 1.304-2.778 2.773-2.778 1.47 0 2.774 1.244 2.774 2.778 0 .625-.244 1.173-.592 1.637l6.215 4.98a2.217 2.217 0 0 0 3.37-.742l3.994-8c-.784-.49-1.339-1.323-1.339-2.32C17.195 1.245 18.5 0 20.031 0c1.533 0 2.711 1.244 2.711 2.778 0 .996-.552 1.829-1.338 2.32l3.994 8a2.217 2.217 0 0 0 3.37.74l6.215-4.978c-.287-.464-.53-1.075-.53-1.638a2.775 2.775 0 0 1 2.774-2.778A2.775 2.775 0 0 1 40 7.222Z"/>
                    </svg>
                </template>
                </o-widget-mini>
            </div>
            <div class="me-4">
                <o-widget-mini class="custom-width-widget-extended">
                <template v-slot:card-name>
                    Most Loyal Member Tier Rank
                </template>
                <template v-slot:card-value>
                    {{ gain?.member_tier[0]?.member_name }}
                </template>
                <template v-slot:icon-big>                    
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 24 24">
                        <path fill="#fff" d="M12 .587l3.668 7.432 8.2 1.191-5.934 5.782 1.402 8.177L12 18.897l-7.336 3.863 1.402-8.177L.132 9.21l8.2-1.191L12 .587z"/>
                    </svg>
                </template>
                </o-widget-mini>
            </div>
        </div>
        <div class="d-flex mt-4" v-if="isPointSystemActive">
            <o-widget-table class="w-100">
                <template v-slot:card-name>
                Member Rank
                </template>
                <template v-slot:table-head>
                <tr v-if="fields">
                    <th scope="col">#Rank</th>
                    <th scope="col" colspan="2">Name</th>
                    <th scope="col">Point</th>
                </tr>
                </template>
                <template v-slot:table-body>
                <tr v-for="(item, index) in gain?.member_rank" :key="index">
                    <td scope="row">#{{ index + 1 }}</td>
                    <td colspan="2">{{ item.title }} {{ item.first_name }} {{ item.last_name }}</td>
                    <td>{{ item.points }}</td>
                </tr>
                </template>
            </o-widget-table>
        </div>
        <div class="d-flex mt-4 mb-5">
            <o-widget-table class="mb-5 w-100">
                <template v-slot:card-name>
                Member Tier Rank
                </template>
                <template v-slot:table-head>
                <tr v-if="fields">
                    <th scope="col">#Rank</th>
                    <th scope="col" colspan="2">Name</th>
                    <th scope="col">Tier</th>
                </tr>
                </template>
                <template v-slot:table-body>
                <tr v-for="(item, index) in gain?.member_tier" :key="index">
                    <td scope="row">#{{ index + 1 }}</td>
                    <td colspan="2">{{ item.member_name }}</td>
                    <td>{{ item.tier_name }}</td>
                </tr>
                </template>
            </o-widget-table>
        </div>
    </div>
</template>


<script>
import { 
        OWidgetMini,
        OWidgetTable
    } from '@/components/OmnihControl'
import { 
    ref, onMounted, watch } from 'vue'
import store from '@/store/'
import { usePointSystem } from '@/composables/pointsystem';

export default {
    props:[
        'gain',
        'dashboardMode'
    ],
    setup(props) {
        const { isPointSystemActive } = usePointSystem();
        let fields = ref([
            '#Rank',
            'Name',
            'Point',
            'Tier'
        ]);

        const adminSummary = ref({
            totalCorporates: 0,
            totalBranches: 0,
            totalMerchants: 0,
            totalMembers: 0,
            activeMembers: 0,
            activeCampaigns: 0,
            todayTransactions: 0,
            todayTransactionValue: 0,
            todayNewMembers: 0,
            todayVoucherClaimed: 0
        });

        onMounted(() => {
            if (props.dashboardMode === '') {
                updateAdminSummaryFromStore();
            }
        });

        watch(() => props.dashboardMode, (newMode) => {
            if (newMode === '') {
                updateAdminSummaryFromStore();
            }
        });

        watch(() => store.state.Dashboard.dashboards, (newData) => {
            if (props.dashboardMode === '' && newData && Object.keys(newData).length > 0) {
                updateAdminSummaryFromStore();
            }
        }, { deep: true });

        const updateAdminSummaryFromStore = () => {
            const dashboardData = store.state.Dashboard.dashboards;
            
            if (dashboardData && Object.keys(dashboardData).length > 0) {
                adminSummary.value.totalCorporates = dashboardData.total_corporate || 0;
                adminSummary.value.totalBranches = dashboardData.total_branch || 0;
                adminSummary.value.totalMerchants = dashboardData.total_merchant || 0;
                adminSummary.value.totalMembers = dashboardData.total_member || 0;
                adminSummary.value.activeMembers = dashboardData.active_member || 0;
                adminSummary.value.todayTransactions = dashboardData.today_transaction || 0;
                adminSummary.value.todayTransactionValue = dashboardData.today_transaction_value || 0;
                adminSummary.value.todayNewMembers = dashboardData.today_new_member || 0;
                adminSummary.value.todayVoucherClaimed = dashboardData.today_voucher_claimed || 0;
                adminSummary.value.activeCampaigns = dashboardData.active_campaign || 0;
            }
        };

        return {
            fields,
            adminSummary,
            isPointSystemActive
        }
    },
    components:{
        OWidgetTable,
        OWidgetMini,
    }
}
</script>

<style>

.deals {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
.deals::-webkit-scrollbar {
    display: none;
}
.custom-width-widget-mini{
    width: 300px;
}

.custom-width-widget-extended{
    /* width: 600px; */
    min-width: 300px;
    padding: 0 1rem;
}

/* Mobile Admin Dashboard Styles */
.admin-mobile-container {
    padding: 0.5rem 0;
}

</style>